import React from 'react';
import { StaticDatePickerProps } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

import { ArrowIosBack, ArrowIosForward } from '@lyearn/icons';

import Box from '../Box';
import { datePickerOverrideStyles } from './styles';

const renderInput = () => <></>;

const DEFAULT_PROPS: Partial<
  StaticDatePickerProps<Date | null | undefined, Date | null | undefined>
> = {
  components: {
    LeftArrowIcon: () => <ArrowIosBack className="w-20 h-20" fillColorToken="icon-placeholder" />,
    RightArrowIcon: () => (
      <ArrowIosForward className="w-20 h-20" fillColorToken="icon-placeholder" />
    ),
  },
  views: ['day'],
};

function DatePicker(
  props: Omit<
    StaticDatePickerProps<Date | null | undefined, Date | null | undefined>,
    'renderInput'
  >,
) {
  const { className, disabled, disablePast, minDate, onMonthChange, renderDay, ...rest } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box className={datePickerOverrideStyles}>
        <StaticDatePicker<Date | null | undefined, Date | null | undefined>
          disablePast={disablePast}
          disabled={disabled}
          displayStaticWrapperAs="desktop"
          renderDay={renderDay}
          renderInput={renderInput}
          onMonthChange={onMonthChange}
          minDate={minDate}
          /* 
            on removing reduceAnimations, calendar will break
            (Reason: We change height on month change
            for animations to work we need a fixed height value)
          **/
          reduceAnimations
          {...DEFAULT_PROPS}
          {...rest}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default DatePicker;
